import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  register: (data) => api.post('/api/auth/register', data),
  login: (data) => api.post('/api/auth/login', data),
  me: () => api.get('/api/user/me'),
};

// Dashboard
export const dashboardAPI = {
  overview: () => api.get('/api/dashboard/overview'),
};

// Accounts
export const accountsAPI = {
  list: () => api.get('/api/accounts'),
  get: (id) => api.get(`/api/accounts/${id}`),
};

// Transactions
export const transactionsAPI = {
  list: (params) => api.get('/api/transactions', { params }),
};

// Transfers
export const transfersAPI = {
  domestic: (data) => api.post('/api/transfers/domestic', data),
  international: (data) => api.post('/api/transfers/international', data),
};

// FX
export const fxAPI = {
  rates: () => api.get('/api/fx/rates'),
  quote: (amount, currency) => api.get('/api/fx/quote', { params: { amount, currency } }),
};

// Bills
export const billsAPI = {
  pay: (data) => api.post('/api/bills/pay', data),
};

// Zelle
export const zelleAPI = {
  enrollment: () => api.get('/api/zelle/enrollment'),
  enroll: (data) => api.post('/api/zelle/enroll', data),
  send: (data) => api.post('/api/zelle/send', data),
};

// Wire
export const wireAPI = {
  send: (data) => api.post('/api/wire/send', data),
};

// Cards
export const cardsAPI = {
  list: () => api.get('/api/cards'),
  get: (cardId) => api.get(`/api/cards/${cardId}`),
  freeze: (cardId) => api.post(`/api/cards/${cardId}/freeze`),
  updateSettings: (cardId, data) => api.put(`/api/cards/${cardId}/settings`, data),
  linkExternal: (data) => api.post('/api/cards/link-external', data),
  unlinkExternal: (cardId, bankName) => api.delete(`/api/cards/${cardId}/unlink/${encodeURIComponent(bankName)}`),
};

// Social Security
export const socialSecurityAPI = {
  claim: (data) => api.post('/api/social-security/claim', data),
  claims: () => api.get('/api/social-security/claims'),
};

// External Accounts
export const externalAccountsAPI = {
  list: () => api.get('/api/external-accounts'),
  add: (data) => api.post('/api/external-accounts', data),
  remove: (id) => api.delete(`/api/external-accounts/${id}`),
};

// External Transfers
export const externalTransfersAPI = {
  send: (data) => api.post('/api/transfers/external', data),
};

// Profile
export const profileAPI = {
  get: () => api.get('/api/profile'),
  update: (data) => api.put('/api/profile', data),
  changePassword: (data) => api.put('/api/profile/change-password', data),
  changeUsername: (data) => api.put('/api/profile/change-username', data),
};

export default api;
